"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
const validations_1 = require("../../../utils/validations");
const TrackerMessage_1 = __importDefault(require("../TrackerMessage"));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["UNKNOWN_PEER"] = "RTC_UNKNOWN_PEER"; // TODO: RTC_ prefix in value for backwards compatibility
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
class ErrorMessage extends TrackerMessage_1.default {
    constructor({ version = TrackerMessage_1.default.LATEST_VERSION, requestId, errorCode, targetNode }) {
        super(version, TrackerMessage_1.default.TYPES.ErrorMessage, requestId);
        (0, validations_1.validateIsOneOf)('errorCode', errorCode, Object.values(ErrorMessage.ERROR_CODES));
        (0, validations_1.validateIsNotEmptyString)('targetNode', targetNode);
        this.errorCode = errorCode;
        this.targetNode = targetNode;
    }
}
exports.default = ErrorMessage;
ErrorMessage.ERROR_CODES = ErrorCode; // TODO can we remove this and use the enum object directly?
//# sourceMappingURL=ErrorMessage.js.map